import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import { Divider, Layout, SelectReduxFormWrapper, Typography, Button } from '@hub-mono/ui';
import CreateCustomerForm from './create';

class Customer extends PureComponent {
    static propTypes = {
        customers: PropTypes.array.isRequired,
        formName: PropTypes.string,
        fieldName: PropTypes.string,
    };

    constructor(props) {
        super(props);
        this.state = { isFormOpen: false };
    }

    toggleForm = () => this.setState(state => ({ isFormOpen: !state.isFormOpen }));

    render() {
        const { isFormOpen } = this.state;
        const { customers, formName, fieldName } = this.props;

        return (
            <Layout stack gap={24} pt={24}>
                <Layout gap="--Spacing-150" stack>
                    {isFormOpen ? (
                        <CreateCustomerForm formName={formName} fieldName={fieldName} onDismiss={this.toggleForm} />
                    ) : (
                        <>
                            <Typography variant="label" size="large" prominent>
                                Select Client
                            </Typography>
                            <Layout stack gap={24}>
                                <Field
                                    name="customers"
                                    component={SelectReduxFormWrapper}
                                    filter="contains"
                                    optionValue="_id"
                                    optionLabel={item => (Object.keys(item).length ? item.name : '')}
                                    options={customers}
                                    multiple
                                />
                                <Layout>
                                    <Button
                                        onClick={this.toggleForm}
                                        variant="text"
                                        startIcon="add"
                                        dataCy="add-new-client"
                                    >
                                        Add new Client
                                    </Button>
                                </Layout>
                            </Layout>
                        </>
                    )}
                </Layout>
                <Divider />
            </Layout>
        );
    }
}

export default Customer;
